import { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { getEmployerJPState } from '@restworld/utils-common';
import { EmployerCard, EmployerCardHeader, EmployerCardFooter, EmployerCardInfo } from './employer-card';
import { format } from 'date-fns';
import { it } from 'date-fns/locale';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function badgeVariant(_ref) {
  var jpState = _ref.jpState;
  var variant = 'neutral';

  switch (jpState) {
    case 'draft':
      return 'warning';

    case 'open':
      return 'success';

    case 'closed':
      return 'disabled';

    default:
      return variant;
  }
}
export function bagdeText(_ref2) {
  var jpState = _ref2.jpState,
      lastStatusChangeDate = _ref2.lastStatusChangeDate,
      t = _ref2.t;

  switch (jpState) {
    case 'draft':
      return t('draft');

    case 'pending_approval':
      return t('pending_approval');

    case 'open':
      return t('open');

    default:
      return "".concat(t('closed'), " ").concat(lastStatusChangeDate ? format(new Date(lastStatusChangeDate), 'dd/MM/yyyy', {
        locale: it
      }) : '');
  }
}
export var EmployerJobListingCard = /*#__PURE__*/memo(function EmployerJobListingCard(_ref3) {
  var jpId = _ref3.jpId,
      status = _ref3.status,
      staffRequested = _ref3.staffRequested,
      labels = _ref3.labels,
      occupationLabel = _ref3.occupationLabel,
      jobTitle = _ref3.jobTitle,
      restaurant = _ref3.restaurant,
      href = _ref3.href,
      candidates = _ref3.candidates,
      domainInterestKey = _ref3.domainInterestKey,
      onClick = _ref3.onClick,
      onRequestChanges = _ref3.onRequestChanges,
      onDuplicate = _ref3.onDuplicate,
      onDeleteDraft = _ref3.onDeleteDraft,
      onPutOffline = _ref3.onPutOffline,
      lastStatusChangeDate = _ref3.lastStatusChangeDate;

  var _useTranslation = useTranslation('job-positions-page'),
      t = _useTranslation.t;

  var jpState = useMemo(function () {
    return getEmployerJPState(status === null || status === void 0 ? void 0 : status.key);
  }, [status === null || status === void 0 ? void 0 : status.key]);
  var labelVariant = useMemo(function () {
    return jpState === 'open' ? 'info' : 'disabled';
  }, [jpState]);
  var currentLabels = useMemo(function () {
    return labels ? [{
      text: "".concat(labels.visits || 0, " ").concat(t('visits')),
      variant: labelVariant
    }, {
      text: "".concat(labels.candidates || 0, " ").concat(t('candidates')),
      variant: labelVariant
    }, {
      text: "".concat(labels.qualified || 0, " ").concat(t('qualified')),
      variant: labelVariant
    }] : [];
  }, [labelVariant, labels, t]);
  var info = useMemo(function () {
    return {
      address: restaurant.address,
      businessName: restaurant.name,
      occupation: occupationLabel,
      openPositions: staffRequested,
      domainInterestKey: domainInterestKey
    };
  }, [domainInterestKey, occupationLabel, restaurant.address, restaurant.name, staffRequested]);
  var notification = useMemo(function () {
    return {
      candidateCount: candidates === null || candidates === void 0 ? void 0 : candidates.count,
      message: candidates === null || candidates === void 0 ? void 0 : candidates.message,
      candidates: candidates === null || candidates === void 0 ? void 0 : candidates.candidates,
      isAllSpontaneous: candidates === null || candidates === void 0 ? void 0 : candidates.isAllSpontaneous
    };
  }, [candidates === null || candidates === void 0 ? void 0 : candidates.candidates, candidates === null || candidates === void 0 ? void 0 : candidates.count, candidates === null || candidates === void 0 ? void 0 : candidates.isAllSpontaneous, candidates === null || candidates === void 0 ? void 0 : candidates.message]);
  return /*#__PURE__*/_jsxs(EmployerCard, {
    href: href,
    onClick: onClick,
    children: [/*#__PURE__*/_jsx(EmployerCardHeader, {
      logo: restaurant.logo,
      title: jobTitle,
      badge: {
        text: bagdeText({
          jpState: jpState,
          t: t,
          lastStatusChangeDate: lastStatusChangeDate
        }),
        variant: badgeVariant({
          jpState: jpState
        })
      },
      statusKey: status === null || status === void 0 ? void 0 : status.key,
      jpId: jpId,
      occupationLabel: occupationLabel,
      onRequestChanges: onRequestChanges,
      onDuplicate: onDuplicate,
      onDeleteDraft: onDeleteDraft,
      onPutOffline: onPutOffline
    }), /*#__PURE__*/_jsx(EmployerCardInfo, {
      info: info
    }), /*#__PURE__*/_jsx(EmployerCardFooter, {
      labels: currentLabels,
      notification: notification
    })]
  });
});
export default /*#__PURE__*/memo(EmployerJobListingCard);